import React,{useEffect} from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { services } from "../Data";



const Services=()=>{
    useEffect(() => {
    document.title =
      "Transportation & Logistics Services | Shivam Transworld";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Explore Shivam Transworld's full truckload, part load, and integrated logistics services designed to support reliable movement of goods across India."
      );
    }

    const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/services");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Transportation & Logistics Services | Shivam Transworld"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Explore Shivam Transworld's full truckload, part load, and integrated logistics services designed to support reliable movement of goods across India."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/services");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Transportation & Logistics Services | Shivam Transworld"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Explore Shivam Transworld's full truckload, part load, and integrated logistics services designed to support reliable movement of goods across India."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);
    return(
        <>
          <div className="spacing-div"></div>

          {/**cards grid */}
           <section className="services-section">
  {/* SUBHEADING */}
  <motion.p
    className="section-label"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    SERVICES
  </motion.p>

  {/* HEADING */}
  <motion.h1
    className="section-title h1-heading"
    initial={{ opacity: 0, y: 35 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: true }}
  >
    Our Transportation & Logistics Services
  </motion.h1>

  {/* SERVICES GRID */}
  <motion.div
    className="services-grid"
    initial="hidden"
    whileInView="visible"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15,
          delayChildren: 0.2,
        },
      },
    }}
  >
    {services.map((service, i) => (
      <motion.div
        className="service-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 50,
            scale: 0.9,
          },
          visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
        whileHover={{
          y: -8,
          scale: 1.04,
        }}
        transition={{ type: "spring", stiffness: 220 }}
      >
         <Link to={`/services/${service.slug}`} className="service-card-link">
        <motion.div
        className="service-icon"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            delay: 0.2,
            type: "spring",
            stiffness: 300,
          }}
        >
          {service.icon}
        </motion.div>

        <h2>{service.title}</h2>
        <p>{service.introDesc}</p>
        </Link>
      </motion.div>
    ))}
  </motion.div>
</section>

    

        </>
    )
}

export default Services;